import _axios from '@/services/axios';
import { Component, Vue } from 'vue-property-decorator';
import WithRender from './balance.html';
import config from "@/settings/config.js";

@WithRender
@Component({
})
export default class Balance extends Vue {

    zesa:string | void ="";
    airtime: string | void = "";
    sa: string | void = "";
    airtel: string | void = "";
    tnm: string | void = "";
    econet: string | void = "";


    async mounted() {
        this.airtime = await this.getBalance("zw", "hot");
        this.sa = await this.getBalance("za", "free");
        this.airtel = await this.getBalance("mw", "airtel");
        this.tnm = await this.getBalance("mw", "tnm");
        this.econet = await this.getBalance("zw", "usdeconet");
        this.zesa = await this.getBalance("zw", "esol");
    }

    async getBalance(isoCountry: string, provider:string ):Promise<string | void> {
        try{
            const result = await _axios.get(`${config.gateway}recharge-api/balance?isoCountry=${isoCountry}&provider=${provider}`);
            console.log(result);
            return result.data;
    } catch (err) {
        console.error(err);
      }
    }
}

